import React from 'react';

function ProjectCard({ title, projectData, onClick }) {
    const { project, submission, testResult, certificate } = projectData;

    if (!project) {
        return null;
    }

    const getStatus = () => {
        if (certificate && testResult?.passed) {
            return { text: 'Completed ✓', class: 'completed' };
        }
        if (testResult?.passed) {
            return { text: 'Test Passed - Awaiting Certificate', class: 'test-passed' };
        }
        if (testResult && !testResult.passed) {
            return { text: 'Test Failed - Retake Available', class: 'test-failed' };
        }
        if (submission?.status === 'accepted') {
            return { text: 'Accepted - Take Test', class: 'accepted' };
        }
        if (submission?.status === 'rejected') {
            return { text: 'Rejected - Resubmit', class: 'rejected' };
        }
        if (submission?.status === 'pending') {
            return { text: 'Pending Review', class: 'pending' };
        }
        return { text: 'Not Started', class: 'not-started' };
    };

    const status = getStatus();

    return (
        <div className="project-card" onClick={onClick}>
            <div className="card-header">
                <h3>{title}</h3>
                <span className={`status-badge ${status.class}`}>{status.text}</span>
            </div>

            <div className="card-body">
                <h4>{project.name}</h4>
                <p className="project-category">{project.category}</p>

                {project.description && (
                    <p className="project-description">{project.description.substring(0, 100)}...</p>
                )}

                <div className="project-progress">
                    {submission && (
                        <div className="progress-item">
                            <span className="icon">📝</span>
                            <span>Submitted</span>
                        </div>
                    )}
                    {testResult && (
                        <div className="progress-item">
                            <span className="icon">{testResult.passed ? '✅' : '❌'}</span>
                            <span>Test: {testResult.score}%</span>
                        </div>
                    )}
                    {certificate && (
                        <div className="progress-item">
                            <span className="icon">🎓</span>
                            <span>Certificate Ready</span>
                        </div>
                    )}
                </div>
            </div>

            <div className="card-footer">
                <button className="btn btn-link">View Details →</button>
            </div>
        </div>
    );
}

export default ProjectCard;
